"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLContentUtils = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
class URLContentUtils {
    static makeGETRequest(endpoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield (0, axios_1.default)({
                method: "get",
                url: endpoint,
            });
            return result.data;
        });
    }
    static makePOSTRequest(endpoint, content) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield (0, axios_1.default)({
                method: "post",
                url: endpoint,
                data: content,
            });
            return result.data;
        });
    }
}
exports.URLContentUtils = URLContentUtils;
//# sourceMappingURL=URLContentsUtils.js.map